import { connect } from 'react-redux'
import { values } from 'lodash'
import BillingList from './BillingList'
import { getBillingAccounts } from 'features/Billing/Billing.actions'

const stateToProps = ({ billing }) => ({
  billingAccounts: values(billing.billingAccounts),
})

const dispatchToProps = {
  getBillingAccounts,
}

export default connect(stateToProps, dispatchToProps)(BillingList)



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Billing/BillingList/BillingList.container.js